import React from "react"

import { css } from "@emotion/react"

import { ButtonElement } from "./button.element"

export const PageFloatingButton: React.FunctionComponent<
    IPageFloatingButtonProps
> = props => {
    return (
        <div
            css={[
                styles.container,

                css({
                    zIndex: props.zIndex || 350,
                }),
            ]}
            className={props.className}
        >
            <ButtonElement
                className={props.buttonClassName}
                icon={props.icon}
                isRightIcon={props.isRightIcon}
                size="large"
                isLoading={props.isLoading}
                htmlType="button"
                type="primary"
                label={props.label}
                disabled={props.disabled}
                onClick={props.onClick}
            />
        </div>
    )
}

const styles = {
    container: css({
        position: "fixed",
        bottom: 50,
        left: "50%",
        transform: "translateX(-50%)",
        width: "fit-content",
    }),
}

interface IPageFloatingButtonProps {
    className?: string
    zIndex?: number
    buttonClassName?: string
    label: string
    isLoading?: boolean
    icon?: string | React.ReactNode
    isRightIcon?: boolean
    disabled?: boolean
    onClick?: React.MouseEventHandler<HTMLElement>
}
